import * as React from 'react';
import {styled, alpha} from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import "./Header.css";
import avatar from "../../assets/images/header/avatar_12.jpg"
import {useEffect, useState} from "react";
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import {RouteInfo} from "../../route/RouteHelper";
import LogOut from "../Sidebar/LogOut";
import {css} from "@emotion/css";
import DarkModeToggle from "../darkModeToggle/DarkModeToggle";
import SidebarMobile from "../Sidebar/SidebarMobile";
import RaikoDefaultDialogPage, {DialogSize} from "../defaultDialogPage/RaikoDefaultDialogPage";
import ThemeColorToggle from "../ThemeToggle/ThemeColorToggle";
import {ProfileService} from "../../pages/profile/ProfileService";
import {Skeleton} from "@mui/material";
import {Link} from "react-router-dom";


const Header = () => {
    const StyledMenu = styled((props) => (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            {...props}
        />
    ))(({theme}) => ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 180,
            color:
                theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
            boxShadow:
                'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
                padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                '&:active': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    }));
    const [openDialog, setOpenDialog] = useState(false)
    const handleClickOpen = () => {
        setOpenDialog(true)
        setAnchorEl(null);
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClickClose = () => {
        setOpenDialog(false)
    }

    const [adminName, setAdminName] = useState("ادمین")
    const [avatarUrl, setAvatarUrl] = useState("");

    const [state, setState] = React.useState({
        top: false,
    });
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
        setAnchorEl(null)
    };
    const list = (anchor) => (
        <Box
            sx={{width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250}}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon/> : <MailIcon/>}
                            </ListItemIcon>
                            <ListItemText primary={text}/>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider/>
            <List>
                {['All mail', 'Trash', 'Spam'].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon/> : <MailIcon/>}
                            </ListItemIcon>
                            <ListItemText primary={text}/>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const [openSettingDialog, setOpenSettingDialog] = useState(false);

    const service = new ProfileService()
    const [adminNameLoadingState, setAdminNameLoadingState] = useState(false);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            setAdminNameLoadingState(true)
            service.getProfileDetail().then(({info, url}) => {
                setAdminName(`${info.firstName} ${info.lastName}`)
                setAvatarUrl(url)
                setAdminNameLoadingState(false)
            }).catch(reason => {
                setAdminNameLoadingState(false)
            })
        }
    }, [])

    return (
        <>
            {
                <LogOut
                    openDialog={openDialog}
                    handleClickClose={handleClickClose}
                />
            }
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setOpenSettingDialog(false)
                }}
                open={openSettingDialog}
                selectedValue={""}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle="تنظیمات">
                <ThemeColorToggle/>
            </RaikoDefaultDialogPage>


            <header>
                <section className="headerContainer">

                    <div id="dropdown-menu">
                        <button
                            id="btn-dropdown"
                            aria-controls={open ? 'demo-customized-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            <Avatar className={css`background: var(--color-primary);`} id="avatar" alt="avatar"
                                    src={avatarUrl ? avatarUrl : avatar}/>

                            {adminNameLoadingState &&
                                <Skeleton variant="rectangular" className={css`padding: 16px;
                                  min-width: 120px;`}/>
                            }


                            {!adminNameLoadingState &&
                                <span id="hello" style={{marginLeft: "4px"}}>سلام،</span>
                            }
                            {!adminNameLoadingState &&
                                <span id="username">{adminName}</span>
                            }
                            {!adminNameLoadingState &&
                                <span id="hello" style={{marginRight: "4px"}}>عزیز</span>
                            }
                            <div id="btn-dropdown-chevron" className="dropdown-item-icon chevronDown-icon"/>
                        </button>
                        <StyledMenu
                            id="demo-customized-menu"
                            MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            <Link to={RouteInfo.Profile.globalUrl}>
                                <MenuItem onClick={handleClose} disableRipple>
                                    <section className="dropdown-item-icon account-icon"/>
                                    حساب کاربری
                                </MenuItem>
                            </Link>
                            <MenuItem onClick={_ => {
                                setOpenSettingDialog(true)
                                handleClose()
                            }} disableRipple>
                                <section className="dropdown-item-icon setting-icon"/>
                                تنظیمات
                            </MenuItem>
                            <Divider sx={{my: 0.5}}/>
                            <MenuItem onClick={handleClickOpen} disableRipple>
                                <section className="dropdown-item-icon logOut-icon"/>
                                خروج
                            </MenuItem>
                        </StyledMenu>
                    </div>
                    <DarkModeToggle/>
                    <div className={css`flex-grow: 1`}>
                        <SidebarMobile/>
                    </div>
                </section>
            </header>
        </>

    )
}
export default Header;
